import { MSEC_IN_SEC, MSEC_IN_MIN, MSEC_IN_HOUR, SEC_IN_MIN, MIN_IN_HOUR } from '@wellbeingxltd/fe-lib/constants'

export const getChangedValues = (values, initialValues) =>
    Object.entries(values).reduce((acc, [key, value]) => {
        const hasChanged = initialValues[key] !== value

        if (hasChanged) {
            acc[key] = value
        }

        return acc
    }, {})

// Used only for Timer
export const parseTime = timeInMilliSeconds => {
    if (!timeInMilliSeconds) {
        console.warn('[parseTime]', { timeInMilliSeconds })
        return {}
    }

    let msec = timeInMilliSeconds
    let hh = Math.floor(msec / MSEC_IN_SEC / SEC_IN_MIN / MIN_IN_HOUR)
    msec -= hh * MSEC_IN_HOUR
    let mm = Math.floor(msec / MSEC_IN_SEC / SEC_IN_MIN)
    msec -= mm * MSEC_IN_MIN
    let ss = Math.floor(msec / MSEC_IN_SEC)
    msec -= ss * MSEC_IN_SEC
    return { hh, mm, ss }
}
